import { InfoButton } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import type { Ticket, TicketPriceModalInfoProps } from '../../../model';
import { useToggle } from '../../../../../../../../common/custom-hooks/toggle';
import { getTripTotalPrice } from '../../../../../../utils/resultUtils';
import PriceBreakdownModal from '../../../../PriceBreakdownModal';
import type { TravelerPriceBreakdown } from '../../../../../../models';

interface TicketPriceInfoWrapperProps {
  isRyanAirTicketingOrMarketingCarrierPresent: boolean;
  isVI: boolean;
  ticket: Ticket;
  ticketPriceModalInfo: TicketPriceModalInfoProps;
}

export const TicketPriceInfoWrapper = ({
  isRyanAirTicketingOrMarketingCarrierPresent,
  isVI,
  ticket,
  ticketPriceModalInfo,
}: TicketPriceInfoWrapperProps) => {
  const { t } = useTranslation();
  const { isOpen, handleOpen, handleClose } = useToggle();

  const infoButtonLabel = t('ScreenReader.PriceSpecification.InfoButton');

  const {
    discountAmount,
    marketingCarrierNames,
    paymentMethodPrices,
    preSelectedExtraProducts,
    travelerPrices,
    travelerPriceBreakdown,
  } = ticketPriceModalInfo;
  const { cfarTicketPrices, flexibleTicketPrices } = ticket;
  return (
    <>
      <InfoButton
        data-testid="ticket-info-and-price-specification"
        label={infoButtonLabel}
        onClick={handleOpen}
      />
      {ticketPriceModalInfo && (
        <PriceBreakdownModal
          cfarTicketPrices={cfarTicketPrices}
          discountAmount={discountAmount}
          flexibleTicketPrices={flexibleTicketPrices}
          handleClose={handleClose}
          isOpen={isOpen}
          isRyanAirTicketingOrMarketingCarrierPresent={isRyanAirTicketingOrMarketingCarrierPresent}
          isVI={isVI}
          marketingCarrierNames={marketingCarrierNames}
          paymentMethodPrices={paymentMethodPrices}
          preSelectedExtraProducts={preSelectedExtraProducts}
          totalPrice={getTripTotalPrice(travelerPrices, flexibleTicketPrices, cfarTicketPrices)}
          travelerPriceBreakdown={travelerPriceBreakdown as TravelerPriceBreakdown[]}
        />
      )}
    </>
  );
};
